// 세리사무소 사이드바가 읽는 데이터 — 시안(세무대리인포털_메인_v8.html)의 목업이다.
//
// 메일·결재·메신저·일정·게시판·문서함은 각각 실제 모듈이 따로 있거나(게시판·ONEFFICE·
// ONECHAMBER) 아직 없다(메일·결재·메신저·일정). 사이드바가 그 내용을 어떻게 받아올지는
// 모듈 쪽 API 가 정해져야 해서, 지금은 화면 모양과 동작만 맞춰 두고 값은 여기 모아 둔다.

/** 라벨 색 — r 빨강 · o 주황 · b 파랑 · g 초록 · p 보라 · 빈 값은 회색 */
export type TagTone = 'r' | 'o' | 'b' | 'g' | 'p' | '';

export interface RailApp {
  id: string;
  nm: string;
  /** 패널 머리에 붙는 한 줄 */
  sb: string;
  /** 아이콘 색 갈래 — Layout.zeirishi.module.css 의 타일 색과 짝 */
  cl: 'erp' | 'tax' | 'biz' | 'hr' | 'fin';
  /** 읽지 않음/미결 건수 — 0 이면 배지를 달지 않는다 */
  n: number;
}

/** 협업·문서 앱 — 레일에서 구분선으로 나뉘는 두 묶음 */
export const RAIL_APPS: RailApp[] = [
  { id: 'mail', nm: '메일', sb: '수신함', cl: 'erp', n: 7 },
  { id: 'appr', nm: '전자결재', sb: '미결 문서', cl: 'tax', n: 3 },
  { id: 'msg', nm: '메신저', sb: '대화', cl: 'hr', n: 2 },
  { id: 'cal', nm: '일정', sb: '오늘', cl: 'fin', n: 0 },
  { id: 'board', nm: '게시판', sb: '사무소 공지', cl: 'erp', n: 1 },
];

export const RAIL_DOCS: RailApp[] = [
  { id: 'office', nm: 'ONEFFICE', sb: '문서 작성', cl: 'biz', n: 0 },
  { id: 'chamber', nm: 'ONECHAMBER', sb: '문서 보관·증적', cl: 'biz', n: 0 },
];

/** 목록 한 줄 — 앱마다 쓰는 칸이 조금씩 다르다 */
export interface WRow {
  /** 수임기업 id — 회사를 고르면 그 회사 것이 위로 올라오고 표시가 붙는다 */
  co?: string;
  who?: string;
  org?: string;
  sj?: string;
  pv?: string;
  tm: string;
  /** 읽지 않음 수 — 메일·게시판은 0/1, 메신저는 건수 */
  un?: number;
  /** 메신저 단체방 */
  grp?: boolean;
  tt?: string;
  md?: string;
  tag?: [string, TagTone];
}

export const WDATA: { [id: string]: WRow[] } = {
  mail: [
    { co: 'hb', who: '김재무 팀장', org: '(주)한빛테크', sj: '8월 법인카드 영수증 12건 회신', pv: '요청하신 영수증 첨부합니다. 더현대 건은 대표님 개인 사용이라 별도 처리 부탁드립니다.', tm: '09:12', un: 1 },
    { who: '국세청 홈택스', org: '전자신고', sj: '[안내] 2기 부가가치세 예정신고 기간 안내', pv: '신고기한 2026년 9월 25일. 전자신고 시 세액공제 대상 여부를 확인하시기 바랍니다.', tm: '08:40', un: 1 },
    { co: 'ds', who: '이총무 과장', org: '대성물류(주)', sj: '9월 급여 이체 계좌 변경 건', pv: '박OO 사원 퇴사로 급여 이체 명단에서 제외 부탁드립니다.', tm: '08:05', un: 1 },
    { co: 'mr', who: '현장관리팀', org: '미래건설(주)', sj: '9월 출역일보 송부 (6개 현장)', pv: '동탄·평택·청주 현장 출역일보 첨부드립니다.', tm: '어제', un: 0 },
    { who: '중소벤처기업부', org: '정책자금', sj: '2026 스마트공장 고도화 지원사업 공고', pv: '접수기간 2026.9.16 ~ 10.6. 제조업 중소기업 대상.', tm: '어제', un: 0 },
  ],
  appr: [
    { tt: '(주)웰스바이오 기장 계약 승인', md: '수임계약 · 월 850,000원 · 24개월', who: '박세무 대리 상신', tm: '어제', tag: ['결재 대기', 'o'] },
    { co: 'hb', tt: '한빛테크 부가세 신고 대리 위임장', md: '전자서명 요청 · 고객사 날인 완료', who: '시스템 자동 상신', tm: '09:20', tag: ['서명 대기', 'b'] },
    { tt: '9월 수수료 청구 일괄 (148개사)', md: '청구 총액 42,600,000원', who: '정경리 주임 상신', tm: '09-15', tag: ['결재 대기', 'o'] },
  ],
  msg: [
    { who: '세무 1팀', pv: '부가세 마감 건 오늘까지 확인 부탁드립니다', tm: '10:24', un: 2, grp: true },
    { co: 'hb', who: '한빛테크 김재무', pv: '영수증 보냈습니다. 확인 부탁드려요!', tm: '09:15', un: 0 },
    { who: '박세무 대리', pv: '웰스바이오 계약서 초안 올렸습니다', tm: '어제', un: 0 },
    { co: 'sr', who: '상록수산업 최대표', pv: '대출 건 상담 가능한 시간 있을까요?', tm: '어제', un: 0 },
  ],
  cal: [
    { tm: '09:00', tt: '부가세 예정신고 마감 D-2', md: '대상 4개사 · 전자신고 대기', tag: ['마감', 'r'] },
    { tm: '11:00', tt: '(주)웰스바이오 신규 수임 미팅', md: '화상 · 계약 조건 협의', tag: ['외부', 'b'] },
    { tm: '14:00', tt: '대성물류 월간 경영보고', md: '8월 실적 브리핑 · 자료 준비 완료', tag: ['고객', 'b'] },
    { tm: '16:30', tt: '사무소 주간 업무 회의', md: '대회의실 · 신고 진행률 점검', tag: ['내부', ''] },
  ],
  board: [
    { tt: '2026년 세법 개정 주요 내용 안내', md: '법인세율 구간 조정 및 접대비 한도 변경 사항 정리', who: '사무국', tm: '09-15', un: 1 },
    { tt: '9월 신고 업무 분장표 (확정)', md: '담당자별 수임기업 배정 내역', who: '세무1팀', tm: '09-10', un: 0 },
    { tt: '전자세금계산서 자동수취 시스템 교육 자료', md: '신규 입사자 필독', who: '전산실', tm: '09-08', un: 0 },
  ],
  office: [
    { co: 'hb', tt: '한빛테크_부가세신고서_초안.docx', md: 'AI 작성 · 검토 대기', tm: '2분 전', tag: ['AI 초안', 'p'] },
    { co: 'ds', tt: '대성물류_경영보고서_2026.08.pptx', md: '14페이지 · 자동 생성 완료', tm: '1시간 전', tag: ['발표용', 'b'] },
    { tt: '웰스바이오_기장계약서_v2.docx', md: '박세무 대리 편집 중', tm: '어제', tag: ['공동 편집', 'g'] },
    { tt: '정책자금_제안서_템플릿.docx', md: '세무법인 정담 명의 서식', tm: '09-12', tag: ['서식', ''] },
  ],
  chamber: [
    { tt: '2025년 법인세 신고서 일체 (148개사)', md: '보존기한 2031-03-31 · 원본 위·변조 없음 확인', tm: '2026-03-31', tag: ['법정 보존', 'g'] },
    { tt: '전자세금계산서 원본 보관함 2026', md: '1,842건 · 보관 시점 인증 완료', tm: '자동 적재', tag: ['증적', 'b'] },
    { tt: '수임계약서 원본 (전자서명)', md: '148건 · 계약 만료 알림 설정됨', tm: '상시', tag: ['계약', ''] },
    { co: 'sr', tt: '세무조사 대응 자료 — 상록수산업', md: '소명자료 47건 · 접근 이력 기록 중', tm: '09-14', tag: ['제한 열람', 'r'] },
  ],
};

/** 패널 아래 버튼 두 개 — [보조, 주된 동작] */
export const WFOOT: { [id: string]: [string, string] } = {
  of: ['전체 메뉴', '마이메뉴 설정'],
  co: ['수임기업 관리', '신규 수임 등록'],
  mail: ['수신함 전체', '메일 쓰기'],
  appr: ['결재함 전체', '상신하기'],
  msg: ['전체 대화', '새 대화'],
  cal: ['캘린더 전체', '일정 추가'],
  board: ['게시판 전체', '글쓰기'],
  office: ['내 문서함', '새 문서'],
  chamber: ['보관함 전체', '보관 등록'],
};

/* ══ 우리 사무소 업무 메뉴 ══ */
export interface MenuCat {
  t: string;
  cl: 'erp' | 'tax' | 'biz' | 'hr' | 'fin';
  apps: string[];
}

export const OFFICE_CATS: MenuCat[] = [
  { t: '기장 관리', cl: 'erp', apps: ['기장 현황판', '증빙 수집현황', '마감 관리', '업무 배정'] },
  { t: '신고 관리', cl: 'tax', apps: ['신고 일정', '전자신고 센터', '신고 이력', '세무조사 대응'] },
  { t: '수임·정산', cl: 'fin', apps: ['수임기업 관리', '계약·수수료', '청구·수납', '성과 리포트'] },
  { t: '부가 서비스', cl: 'biz', apps: ['금융 (대출·보험)', '공공 (정책자금)', '커머스 (MRO)', '정보 (신용·동향)'] },
];

/* ══ 수임기업 ERP 메뉴 — 회사를 고르면 나오는 콘솔 ══ */
export const ERP_CATS: MenuCat[] = [
  { t: '회계', cl: 'erp', apps: ['전표입력', '분개장', '총계정원장', '재무제표', '결산·마감', '경영분석'] },
  { t: '세무·신고', cl: 'tax', apps: ['부가가치세', '원천징수', '법인세', '전자신고', '신고이력'] },
  { t: '증빙·자금', cl: 'fin', apps: ['전자세금계산서', '카드·현금영수증', '증빙함', '자금일보', '예금·차입'] },
  { t: '급여·인사', cl: 'hr', apps: ['급여대장', '4대보험', '연말정산', '인사기록'] },
];

/* ══ 업무 이력 ══
   오늘 치는 큐(승인한 건)와 AI 자동 처리에서 실시간으로 만든다 — 여기 있는 것은 지난 날짜다. */
export interface HistRow {
  tm: string;
  /** me = 내가 승인 · au = AI 자동 — 책임 주체가 사람인지 시스템인지가 가장 중요한 구분 */
  k: 'me' | 'au';
  co: string;
  t: string;
}

export const HIST: { lb: string; rows: HistRow[] }[] = [
  {
    lb: '어제 · 9월 15일 (화)',
    rows: [
      { tm: '17:40', k: 'me', co: '(주)그린푸드', t: '8월 법인카드 증빙 12건 전표 반영' },
      { tm: '16:05', k: 'me', co: '한성전자(주)', t: '8월 부가세 확정신고 전자신고 완료' },
      { tm: '15:20', k: 'me', co: '정민상사(주)', t: '8월 결산 마감 확정' },
      { tm: '11:30', k: 'me', co: '대성물류(주)', t: '운송보험 갱신 견적 제안서 발송' },
      { tm: '09:48', k: 'me', co: '(주)한빛테크', t: '7월 가지급금 인정이자 계산 승인' },
      { tm: '06:20', k: 'au', co: '148개사', t: '전자세금계산서 자동 수취 · 분개 (1,734건)' },
      { tm: '05:55', k: 'au', co: '148개사', t: '은행 거래내역 자동 대사 (2,108건)' },
      { tm: '04:30', k: 'au', co: '미래건설(주)', t: '현장별 노무비 배부 자동 계산' },
    ],
  },
  {
    lb: '9월 14일 (월)',
    rows: [
      { tm: '18:10', k: 'me', co: '상록수산업(주)', t: '세무조사 소명자료 1차 제출' },
      { tm: '14:25', k: 'me', co: '(주)그린푸드', t: '운전자금 대출 제안서 발송' },
      { tm: '10:15', k: 'me', co: '148개사', t: '9월 수수료 청구 일괄 승인 (42,600,000원)' },
      { tm: '06:12', k: 'au', co: '148개사', t: '4대보험 취득·상실 신고 자동 접수 (37건)' },
      { tm: '05:40', k: 'au', co: '148개사', t: '전자세금계산서 자동 수취 · 분개 (1,902건)' },
    ],
  },
  {
    lb: '9월 12일 (금)',
    rows: [
      { tm: '16:50', k: 'me', co: '(주)웰스바이오', t: '신규 수임 계약 체결 · 데이터 이관 개시' },
      { tm: '13:05', k: 'me', co: '대성물류(주)', t: '8월 경영보고서 고객 발송' },
      { tm: '05:38', k: 'au', co: '148개사', t: '전자세금계산서 자동 수취 · 분개 (1,655건)' },
    ],
  },
];

/** 목록에 펼치지 않은 지난 이력 */
export const HIST_ETC = { n: 412, lb: '9월 1일 ~ 11일' };

/** 수임기업 총수 — 목록에 실린 6곳은 그중 일부다 */
export const CLIENT_TOTAL = 148;
